import request from '@/utils/request'


// 查询福彩3D列表
export function listFc3d(query) {
    return request({
        url: '/admin/lottery/fc3d/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期福彩3D数据
export function latestFc3d() {
    return request({
        url: '/admin/lottery/fc3d/latest',
        method: 'get',
    })
}

// 初始化福彩3D数据
export function initAllFc3d() {
    return request({
        url: '/admin/lottery/fc3d/initAll',
        method: 'post'
    })
}

// 补全福彩3D历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/fc3d/fillHistoryData',
        method: 'post'
    })
}

// 初始化福彩3D统计数据
export function initAllFc3dC() {
    return request({
        url: '/admin/lottery/fc3d/initAllC',
        method: 'post'
    })
}

// 刷新福彩3D缓存
export function refreshFc3dCache() {
    return request({
        url: '/admin/lottery/fc3d/refreshCache',
        method: 'delete',
    })
}
// 生成福彩3D
export function generateFc3d(data) {
    return request({
        url: '/admin/lottery/fc3d/generate',
        method: 'post',
        data:data
    })
}

// 查询福彩3D中奖数据
export function getFc3dWinningData(query){
    return request({
        url: '/admin/lottery/fc3d/getWinningData',
        method: 'get',
        params: query
    })
}
// 查询福彩3D历史同期中奖数据
export function getNextFc3dHistory(period){
    return request({
        url: '/admin/lottery/fc3d/getNextHistory?period='+period,
        method: 'get'
    })
}

// 查询福彩3D下期数字频率
export function getNextNumFrequency(query){
    return request({
        url: '/admin/lottery/fc3d/getNextNumFrequency',
        method: 'get',
        params: query
    })
}
